import vial from "../../../imgs/vial.png";
import pens from "../../../imgs/pens.png";
import clinician from "../../../imgs/clinician.png";

const applangaKeyMap = {
  compound: {
    headline: "COMPOUNDED_GLP1_CARD_HEADLINE",
    subheading: "COMPOUNDED_GLP1_CARD_SUBHEADING",
    details: "COMPOUNDED_GLP1_CARD_DETAILS",
    bulletlist: [
      "CHECKLIST_ITEM_COMPOUNDED_SEMAGLUTIDE",
      "CHECKLIST_ITEM_CLINICIAN_VISIT",
      "CHECKLIST_ITEM_WEIGHT_LOSS_TREATMENT",
      "CHECKLIST_ITEM_UNLIMITED_MESSAGING",
      "CHECKLIST_ITEM_FITNESS_PLANS"
    ],
    img: vial
  },
  insurance: {
    headline: "INSURANCE_COVERED_GLP1_CARD_HEADLINE",
    subheading: "INSURANCE_COVERED_GLP1_CARD_SUBHEADING",
    details: "INSURANCE_COVERED_GLP1_CARD_DETAILS",
    bulletlist: [
      "CHECKLIST_ITEM_CLINICIAN_VISIT",
      "CHECKLIST_ITEM_WEIGHT_LOSS_TREATMENT",
      "CHECKLIST_ITEM_UNLIMITED_MESSAGING",
      "CHECKLIST_ITEM_FITNESS_PLANS",
      "CHECKLIST_ITEM_LIVE_SUPPORT_GROUPS"
    ],
    img: pens
  },
  clinician: {
    headline: "DECIDE_WITH_CLINICIAN_CARD_HEADLINE",
    subheading: "DECIDE_WITH_CLINICIAN_CARD_SUBHEADING",
    bulletlist: [
      "CHECKLIST_ITEM_CLINICIAN_VISIT",
      "CHECKLIST_ITEM_WEIGHT_LOSS_TREATMENT",
      "CHECKLIST_ITEM_UNLIMITED_MESSAGING",
      "CHECKLIST_ITEM_FITNESS_PLANS",
      "CHECKLIST_ITEM_LIVE_SUPPORT_GROUPS"
    ],
    img: clinician
  }
};

export default applangaKeyMap;
